import { render, staticRenderFns } from "./LessonPrivateSetting.vue?vue&type=template&id=761b79ea&scoped=true&lang=pug&"
import script from "./LessonPrivateSetting.vue?vue&type=script&lang=ts&"
export * from "./LessonPrivateSetting.vue?vue&type=script&lang=ts&"
import style0 from "./LessonPrivateSetting.vue?vue&type=style&index=0&id=761b79ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761b79ea",
  null
  
)

export default component.exports